import React from "react";
import {GlobalStyles} from "../constants/styles";

const InitialsAvatar = ({ name, size = 50, backgroundColor = "var(--kbs-primary, #00adff)", textColor = "var(--kbs-text-on-primary, #14151a)" }) => {
    // Function to extract initials
    const getInitials = (name) => {
        const normalizedName = typeof name === "string" ? name.trim() : "";
        if (!normalizedName) return "?";

        const initials = normalizedName
            .split(/\s+/)
            .slice(0, 2)
            .map((word) => word.charAt(0).toUpperCase())
            .join("");

        return initials || "?";
    };

    return (
        <div
            style={{
                width: size,
                height: size,
                backgroundColor,
                color: textColor,
                fontSize: size * 0.4,
                fontWeight: "bold",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textTransform: "uppercase",
                fontFamily: "'Poppins', sans-serif",
                boxShadow: GlobalStyles.colors.woodsmoke
            }}
            className="table-avatar"
        >
            {getInitials(name)}
        </div>
    );
};

export default InitialsAvatar;